import React from 'react';
import { Icon } from 'semantic-ui-react';
import { themes } from '../../theme/context';
import { CustomMenuItem, RightIcon } from './style';
export var MenuItem = function (_a) {
    var _b, _c;
    var content = _a.content, color = _a.color, active = _a.active, handleClick = _a.handleClick, id = _a.id, drupalHost = _a.drupalHost;
    var href = '//' + (((_b = themes[id]) === null || _b === void 0 ? void 0 : _b.href) ? ((_c = themes[id]) === null || _c === void 0 ? void 0 : _c.href) + '.' : '') + drupalHost;
    return (React.createElement(CustomMenuItem, { "$active": active, color: color, onClick: handleClick, id: id },
        content,
        active && React.createElement(RightIcon, { href: href },
            React.createElement(Icon, { name: "angle right" }))));
};
//# sourceMappingURL=MenuItem.js.map